type ProxyMappings = { [url: string]: string };
export let proxyMappings: ProxyMappings = {};

export function setProxyMappings(mappings: ProxyMappings) {
  proxyMappings = mappings;
}
